import React, { useState, useEffect } from 'react'
import MicroModal from "micromodal"
import Modal from '../components/common/modal/Modal'
import Button from '../components/common/button/Button'
import Icons from '../components/common/icons/Icons'

async function removeMemberFromPreset(memberID, orgID, presetID) {
    const url = restUrl + '/wp-json/membersync/licensing/v1/org/' + orgID + '/delete/preset/' + presetID + '/datas'
    const nonce = restNonce

    await fetch(url, {
        method: 'POST',
        body: JSON.stringify({
            'datas': [
                { 'value': memberID }
            ],
            'remove_type': 'member'
        }),
        headers:{
            'X-WP-Nonce': nonce,
            'Content-type': 'application/json'
        }
    }).then(resp => {
        return resp.json()
    })
    .then((json) => {
    })
}

const CreateGroupPreset = (props) => {
    if ( !props ) return
    MicroModal.init()

    const orgID = props.orgID

    const [modalTitle, setModalTitle] = useState('')
    const [errorMessage, setErrorMessage] = useState('')
    const [selectedMembers, setSelectedMembers] = useState( props.selectedMembers?.selected ?? [] )
    const [processingPreset, setProcessingPreset] = useState(false)
    
    if ( modalTitle === '' ) setModalTitle(props.type === "edit" ? "Edit Member Preset" : "New Member Preset")

    const modalID = props.type === "edit" ? "msync-org-edit-group-preset-" + props.presetID : "msync-org-create-group-preset"

    const handleRemoveMember = async (memberID) => {
        await removeMemberFromPreset(memberID, props.orgID, props.presetID);
        setSelectedMembers(prevMembers => prevMembers.filter(member => member.id !== memberID));
    };

    async function editGroupPreset(name, members, presetID, type, orgID){

        const url = restUrl + '/wp-json/membersync/licensing/v1/org/' + orgID + '/edit/preset'
        const nonce = restNonce
    
        let groupPresetEdited = false
        let error = ''
    
        const res = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'name': name,
                'datas': members,
                'type': 'member',
                'preset_id': presetID
            }),
            headers:{
                'X-WP-Nonce': nonce,
                'Content-type': 'application/json'
            }
        })
        
        setProcessingPreset(false)
        props.afterEdit()
        MicroModal.close(modalID)
    }

    async function addGroupPreset(name, members, type, orgID){

        const url = restUrl + '/wp-json/membersync/licensing/v1/org/' + orgID + '/create/preset'
        const nonce = restNonce
    
        let groupPresetEdited = false
        let error = ''
    
        const res = await fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'name': name,
                'datas': members,
                'preset_type': 'member',
            }),
            headers:{
                'X-WP-Nonce': nonce,
                'Content-type': 'application/json'
            }
        })
        
        setProcessingPreset(false)
        props.afterEdit()
        MicroModal.close(modalID)
    }

    useEffect(() => {
        if ( processingPreset ) {
            const presetName = tangibleFields.store.getValue('membersync-org-group-preset-name')
            const members = tangibleFields.store.getValue('membersync-org-group-preset-members')
            if ( props.type === 'edit' ) {
                editGroupPreset( presetName, members, props.presetID, props.type, props.orgID )
            } else {
                addGroupPreset( presetName, members, props.type, props.orgID )
            }
        }
    }, [processingPreset])

    return (
        <> 
            <Modal 
                modalId={modalID} 
                buttonTitle='' 
                modalHeading={props.type === 'edit' ? 'Manage Member Preset' : 'Create Member Preset'}
            >
                <main className="msync-modal__body">
                    <span>{errorMessage}</span>
                    <div className="membersync-org-modal-row">
                        {
                            tangibleFields.render({
                                type: 'text',
                                label: 'Preset Name',
                                name: 'membersync-org-group-preset-name',
                                value: props.presetTitle,
                                wrapper: {
                                    class: 'membersync-org-group-preset-name'
                                }
                            })
                        }
                    </div>
                    <div className="membersync-org-modal-row">
                        {
                          tangibleFields.render({
                            type: 'combo-box',
                            label: 'Add Members',
                            name: 'membersync-org-group-preset-members',
                            // isAsync: true,
                            multiple: true,
                            choices: props.members
                            // ajaxAction: 'get_users',
                            // asyncArgs: {
                            //     type: 'member',
                            //     org: orgID
                            // }
                          })
                        }
                    </div>
                    <table className="msync-table membersync-org-modal-row">
                        <thead className="msync-table-header membersync-org-license-preset-modal-title">
                            <tr>
                                <th className="msync-table__cell msync-table__cell--heading">
                                    Member Name
                                </th>
                                <th className="msync-table__cell msync-table__cell--heading">
                                    Actions
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            selectedMembers && selectedMembers.map((member) => {
                                return (
                                    <tr className="membersync-org-license-preset-modal-content" key={member.id}>
                                        <td className="msync-table__cell">
                                            { member.title }
                                        </td>
                                        <td className="msync-table__cell">
                                            <Button 
                                                className="msync-button--is-style-link msync-button--is-theme-destructive" 
                                                aria-label="Remove member" 
                                                onClick={() => handleRemoveMember(member.id)}
                                            >
                                                <Icons type='close' color='red' />
                                                <span className="msync-visually-hidden">Remove member</span>
                                            </Button>
                                        </td>
                                    </tr>
                                )
                            })
                        }
                        </tbody>
                    </table>
                </main>
                <footer className="msync-modal__footer"> 
                    <Button 
                        className="msync-button--is-style-outline msync-button--is-theme-destructive" 
                        onClick={() => {
                            console.log('modalID : ', modalID)
                            MicroModal.close(modalID)
                        }}
                        isDisabled={ processingPreset } 
                    >
                        Cancel
                    </Button>
                    <Button 
                        type="button" 
                        onClick={() => {
                            setProcessingPreset(true)
                        }}
                        isDisabled={ processingPreset }
                    >
                        Save
                    </Button>
                </footer>
            </Modal>
        </>
    );
};

export default CreateGroupPreset;
